// ATS-related copy for the company profile section
// Exported as default and consumed under strings.companyProfile.ats

const companyProfileAts = {
  pageTitle: 'Applicant tracking (ATS)',
  tab: 'Applicant tracking (ATS)',
  descriptionTitle: 'Connect your ATS to keep hiring in one place.',
  descriptionBullets: [
    'Applicants who apply to your jobs are created in your ATS.',
    'People added to your network are pushed to your ATS as candidates.',
  ],
  detectedPrefix: 'Detected ATS:',
  detectionNotePrefix: 'Detected from job source URL:',
  apiKeyLabel: 'ATS API key',
  apiKeyPlaceholder: 'Paste your key',
  apiKeyHelp:
    'We use this key only to create candidates and attach applications. Your key is encrypted and won’t be shown again.',
  ctaConnect: 'Connect ATS',
  disconnect: 'Disconnect ATS',
  success: 'Your ATS is connected. New applicants and network talent will be synced automatically.',
  error: 'We couldn’t save your key. Check the value and try again.',
  learnMore: 'Where to find my ATS API key?',
  learnMoreHref: 'https://help.getro.com',
  toggles: {
    sendApplicants: 'Send job applicants to my ATS',
    sendNetworkMembers: 'Send newly added network members to my ATS',
  },
  status: {
    titleConnected: 'ATS connected',
    titleNotConnected: 'No ATS connected',
    contentConnected: 'Your ATS is connected.',
    contentConnectedWithProvider: 'Connected to [provider].',
    contentNotConnected: 'Connect your ATS to sync applicants and network talent automatically.',
  },
  syncStatusTitle: 'ATS sync status',
  syncCounts: {
    total: 'Total',
    synced: 'Synced',
    failed: 'Failed',
  },
  settings: {
    title: 'Gem settings',
    projectLabel: 'Gem project',
    ownerLabel: 'Gem owner',
    selectProject: 'Select project',
    selectOwner: 'Select owner',
    lockedHint: '🔒 Project and owner are locked. Disconnect to change.',
    save: 'Save',
    savedSuccess: 'Successfully saved settings.',
    savedError: 'Failed to save settings.',
    disconnectConfirm: 'Disconnecting will remove the ATS key and clear synced links. Continue?',
    unknown: 'Unknown',
  },
};

export default companyProfileAts;
